/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Cut {
  /**
   * Inclusively cut a string between two ends
   *
   * @public
   * @function f1.cut
   * @param start the zero index of the cut
   * @param end the index above the last index (zero-indexed), or undefined if you want to include the rest of the string
   * @param s any string
   * @example
   *
   * ```ts
   * cut(0, 2, 'abcd') <=> 'abcd'.slice(0, 2)
   * cut(0, undefined, 'abcd abcd') <=> 'abcd abcd'.slice(0)
   * ```
   */
  (start: number, end: number | undefined, s: string): string;
  (start: number, end: number | undefined): (s: string) => string;
}

/**
 * @see Cut
 */
export default (start: number, end: number | undefined, s: string) => {
  return s.slice(start, end);
};
